"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineMargin = void 0;
const getOrderLineMargin = (config, type) => {
    let margin = 0;
    switch (type) {
        case "GOLF": {
            const golf_config = config;
            const { green_fee } = golf_config;
            // Green Fee
            margin =
                green_fee?.margin * golf_config.where_when_who?.number_of_golfers;
            break;
        }
        case "HOTEL": {
            const hotel_config = config;
            margin = hotel_config.rooms.rooms.reduce((acc, room) => {
                const margin = room?.margin || 0;
                return acc + margin * hotel_config.where_when_who.number_of_nights;
            }, 0);
            break;
        }
        case "TRANSFER": {
            break;
        }
        case "CUSTOM": {
            const custom_config = config;
            margin = custom_config?.product_service?.margin || 0;
            break;
        }
    }
    return margin;
};
exports.getOrderLineMargin = getOrderLineMargin;
